/* global PublicKeyCredential */
import React, { useEffect, useState} from 'react';
import "./Login.css"

const PasskeySignin = ({ onLoginSuccess }) => {
    const [days, setDays] = useState(0);
    useEffect(() => {
        const past = new Date("2024-09-22");
        const now = new Date();

        const diffInMs = now - past;
        const d = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        setDays(d - 1);
    }, []);
    const handlePasskeySignin = async () => {
        const _options = await fetch('https://server.ben-bea.com/webauthn/signinRequest', {
            credentials: 'include'
        });

        const decoded_options = JSON.parse(await _options.json());
        const options = PublicKeyCredential.parseRequestOptionsFromJSON(decoded_options);

        console.log(decoded_options)

        // To abort a WebAuthn call, instantiate an AbortController.
        const abortController = new AbortController();

        // Invoke WebAuthn to authenticate with a passkey.
        const credential = await navigator.credentials.get({
            publicKey: options,
            signal: abortController.signal,
            mediation: 'required'
        });

        // Encode and serialize the PublicKeyCredential.
        const _result = credential.toJSON();
        const result = JSON.stringify(_result);

        // Encode and send the credential to the server for verification.  
        const response = await fetch('https://server.ben-bea.com/webauthn/signinResponse', {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            credentials: 'include',
            body: result
        });

        if (response.ok) {
            onLoginSuccess();
        }
    };

    return (
        <div className="login-container">
          <button onClick={handlePasskeySignin}>{days} days</button>
        </div>
    );
};

export default PasskeySignin;